// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Extra from "../Specular.Dom.Extra/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
import * as Utils_Elm from "../Utils.Elm/index.js";
var toDomEvent = Unsafe_Coerce.unsafeCoerce;
var specularView = function (widget$prime) {
    return function (jq) {
        return function (state) {
            return function (dispatch) {
                var update = function (updateState) {
                    return updateState(state);
                };
                var init = Specular_Dom_Extra.runWidgetInJQuery(jq)(Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder))(function (updateState) {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(state)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "event";
                        }
                    })())(Data_Symbol.SProxy.value)(updateState)))(function (stateDyn) {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(widget$prime(stateDyn)(Specular_Callback.mkCallback((function () {
                            var $0 = Effect_Class.liftEffect(Effect_Class.monadEffectEffect);
                            return function ($1) {
                                return $0(dispatch($1));
                            };
                        })())))(function (action) {
                            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "fire";
                                }
                            })())(Data_Symbol.SProxy.value)(updateState));
                        });
                    });
                }));
                return Utils_Elm.onInitOrUpdate(jq)(init)(update);
            };
        };
    };
};
export {
    specularView,
    toDomEvent
};
//# sourceMappingURL=index.js.map
